export default "__VITE_ASSET__aa23338f__"